goog.provide('el8.data.referencedUsers');

goog.require('el8.model.base');
goog.require('el8.service.urls');


el8.data.referencedUsers = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('fullName');
    _class.addStringProperty('staffType');

    _class.prototype.isPhysician = function() { return this.getStaffType().cmp('Physician'); };
    _class.prototype.isOfficeStaff = function() { return this.getStaffType().cmp('OfficeStaff'); };
    _class.prototype.isPatient = function() { return this.getStaffType().cmp('Patient'); };

    return new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlFn: function(id) {
            var url = el8.service.urls.get('referencedUsers', [id]);
            if (!url) {
                url = '/referenced-users/'+id+'/';
                if (el8Globals.APP === 'access' || el8Globals.APP === 'passport') {
                    // fallback for printouts, which don't have the URL service initialized
                    url = '/'+el8Globals.APP+url;
                }
            }
            return url;
        }
    });
})();
